import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';
import { useBreakpoint } from '@/hooks';
import { WhatsApp } from '@mui/icons-material';
import { Box, useTheme } from '@mui/material';

export const WhatsappContactSection = () => {
  const user = useUser();
  const { isDesktop } = useBreakpoint();
  const theme = useTheme();

  const handleClick = () => {
    window.open(
      `https://wa.me/${user.data?.profile?.coach_phone?.replace(/\D/g, '')}`,
      '_blank',
    );
  };

  if (isDesktop) {
    return (
      <WhatsApp
        fontSize="medium"
        htmlColor={theme.palette.whatsapp.main}
        onClick={handleClick}
      />
    );
  }

  const hasCoachPhone = Boolean(user.data?.profile?.coach_phone);
  return (
    <>
      {hasCoachPhone && (
        <Box
          onClick={handleClick}
          sx={{
            width: 40,
            height: 40,
            borderRadius: '12px',
            backgroundColor: theme.palette.whatsapp.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          <WhatsApp fontSize="medium" htmlColor="#fff" />
        </Box>
      )}
    </>
  );
};
